import { axios } from '@src/plugins/axios'

class EquipoAsignadoApiRepository {
  static async updateEquipoAsignado(payload) {
    const { fk_idPersonal: idPersonal, id, ...rest } = payload
    delete rest.Personal
    delete rest.URL

    await axios.put(`/PoliciaCuadrantes/Equipamiento/personal/${idPersonal}/equipamiento/${id}`, {
      ...rest,
      fk_idPersonal: idPersonal,
    })
  }
}

export default EquipoAsignadoApiRepository
